module.exports = __webpack_public_path__ + "static/media/ComexCargo.b9e67145.png";